import React, { useEffect } from 'react';
import avatar from './images/avatar.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Fade from 'react-reveal/Fade';

import html1 from './images/html1.png';
import css1 from './images/csss.png';
import bootstrap1 from './images/bootstrap.jpg';
import js from './images/js.jpg';
import react1 from './images/react1.png';

import landing from './images/landing.jpg';
import responsive from './images/responsive.png';
import webapp from './images/webapp.jpg';
import pwa from './images/pwa1.jpg';
import custom from './images/custom.jpg';

import touch from './images/touch.jpg';
import touchLeft from './images/touch-left.jpg';

function Loader() {
    setTimeout(() => {
        document.querySelector('.loader-container').style.display = 'none';
    }, 1700)
    
    return(
        <>
            <div className='loader-container'>
                <span>S</span>
                <span>S</span>
                <span>S</span>
            </div>
        </>
    );
}

function Nav() {
    function openNav() {
      document.getElementById("myNav").style.height = "100%";
    }

    function closeNav() {
      document.getElementById("myNav").style.height = "0%";
    }
    
    function DayNight() {
        if (document.getElementById('dark-mode').checked) {
            document.body.style.color = 'white';
            document.body.style.backgroundColor = '#1d1f21';
        }
        else {
            document.body.style.color = 'black';
            document.body.style.backgroundColor = 'lightskyblue';
        }
    }
    
    function windowStatus() {
        if (window.innerWidth > window.innerHeight) {
            document.getElementById('status1').innerHTML = 'Window: Horizontal';
        } else {
            document.getElementById('status1').innerHTML = 'Window: Vertical';
        }
    }
            
    function WindowSize() {
        document.getElementById('status2').innerHTML = `Window Size: ${window.innerWidth}x${window.innerHeight}`;
    }
    
    function connection() {
        if (navigator.onLine) {
            document.getElementById('status3').innerHTML =  'Connection: Online';
        } else {
            document.getElementById('status3').innerHTML =  'Connection: Offline';
        }
    }
    
    function network() {
        document.getElementById('status4').innerHTML = `Connection Type: ${navigator.connection.effectiveType}`;
    }
    
    window.onclick = () => {
        windowStatus();
        WindowSize();
        connection();
        network();
    }
    
    window.ononline = () => {
        connection();
        network();
    }
    
    window.onoffline = () => {
        connection();
        network();
    }
            
    window.onresize = () => {
        windowStatus();
        WindowSize();
    }
    
    return(
        <>
            <div className='navbar'>
                    <h2 data-aos="fade-down" className='logo' onClick={() => window.open('/')}>Sardor's Portfolio</h2>
                <div className='nav-elements'>
                    <div id="myNav" className="overlay">
                      <a className="closebtn" onClick={closeNav}>&times;</a>
                      <div className="overlay-content">
                        <a href="#main-section">Main</a>
                        <a href="#about-section">About Me</a>
                        <a href="#skills-section">My Skills</a>
                        <a href="#projects-section">My Projects</a>
                        <a href="#contact-section">Contact Me</a>
                        <a style={{cursor: 'pointer'}} onClick={() => document.getElementById('myModal1').style.display = 'flex'}>Admin Panel</a>
                      </div>
                    </div>
                    <button id="myBtn" className="fa-solid fa-gear custom-icon" style={{marginRight: '5px'}} onClick={() => document.getElementById('myModal').style.display = 'flex'}></button>
                    <button className='fa-solid fa-bars custom-icon' onClick={openNav}></button>
                </div>
            </div>

            <div id="myModal" className="modal">
                <div className="modal-content">
                    <label style={{color: 'black'}}>
                        Dark Mode
                        <input type='checkbox' onClick={DayNight} id='dark-mode'/>
                    </label>
                    <h3>Status</h3>
                    <p id='status1'></p>
                    <p id='status2'></p>
                    <p id='status3'></p>
                    <p id='status4'></p>
                    <p>Site Language: en-US</p>
                    <i className='fa-solid fa-x' style={{cursor: 'pointer', fontSize: '1.3rem', color: 'black'}} onClick={() => document.getElementById('myModal').style.display = 'none'}></i>
                </div>
            </div>
        </>
    );
}

function Main() {
    useEffect(() => {
        AOS.init({
            duration: '600'
        });
    })
    
    return(
        <>
            <section id='main-section' className='main-part'>
                <div className='main-part_about' data-aos="fade-right">
                    <h2>
                        <Fade top big cascade>
                            Sardor Ziyotov
                        </Fade>
                    </h2>
                    <h3>Middle <span className='yellow-span'>Frontend</span> Developer</h3>
                    <p>
                        <i className="fa-solid fa-circle-info" style={{paddingRight: '5px'}}></i> 
                         Welcome to my site! You can get a brief information about me through this site! Get down ...
                    </p>
                    <div className='btn-container'>
                        <a href='#projects-section'>
                            <button className='custom-btn' style={{marginRight: '15px'}}>
                                <i className="fa-solid fa-diagram-project ipr"></i>
                                Projects
                            </button>
                        </a>
                        <a id='resume' target='_blank' onClick={() => document.getElementById('myModal1').style.display = 'flex'}>
                            <button className='custom-btn'>
                                <i className="fa-solid fa-download ipr"></i>
                                Resume
                            </button>
                        </a>
                    </div>
                    <div className='contacts'>
                        <a target='_blank' href='https://t.me/sardor_ziyotov'>
                            <i className="fa-brands fa-telegram"></i>
                        </a>
                        <a target='_blank' id='phonenum' onClick={() => document.getElementById('myModal1').style.display = 'flex'}>
                            <i className="fa-solid fa-phone"></i>
                        </a>
                        <a target='_blank' href='mailto:sziyotoov@gmail.com'>
                            <i className="fa-solid fa-at"></i>
                        </a>
                    </div>
                </div>
                <div className='other-images'>
                    <img className='avatar' src={avatar} alt='avatar' />
                </div>
            </section>
        </>
    );
}

function AboutMe() {
    return(
        <>
            <section id='about-section' className='about-section'>
                <div className='header-container' data-aos="fade-up">
                    <h2 className='header-text'>About Me</h2>
                    <div className='tags'></div>
                </div>
                <div className='about-container' data-aos="fade-up">
                    <p className='all-text custom-txt'>Sardor Ziyotov</p>
                    <p className='all-text' data-aos="fade-right">
                        <i className="fa-solid fa-user ipr"></i>
                        Age: {new Date().getFullYear() - 2007}
                    </p>
                    <p className='all-text' data-aos="fade-right">
                        <i className="fa-solid fa-graduation-cap ipr"></i>
                        Education: Self study
                    </p>
                    <p className='all-text' data-aos="fade-right">
                        <i className="fa-solid fa-flag ipr"></i>
                        Country: Uzbekistan, Samarkand
                    </p>
                    <div data-aos="fade-up" style={{width: '100%'}}>
                        <a target='_blank' id='openmap' onClick={() => document.getElementById('myModal1').style.display = 'flex'}>
                            <button style={{width: '100%'}} className='custom-btn open-btn'>
                                <i className='fa-solid fa-link ipr'></i>
                                Open Map
                            </button>
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
}

function MySkills() {
    return(
        <>
            <section id='skills-section' className='skills-section'>
                <div className='header-container' style={{marginTop: '0'}} data-aos="fade-up">
                    <h2 className='header-text'>My Skills</h2>
                    <div className='tags'></div>
                </div>
                <div className='skill-cards'>
                    <div className='skill-card' data-aos='fade-right'>
                        <img src={html1} alt='icon' className='hoverable' />
                        <h3>HTML</h3>
                    </div>
                    <div className='skill-card' data-aos='fade-left'>
                        <img src={css1} alt='icon' className='hoverable' />
                        <h3>CSS</h3>
                    </div>
                    <div className='skill-card' data-aos='fade-right'>
                        <img src={bootstrap1} className='hoverable' alt='icon' />
                        <h3>Bootstrap</h3>
                    </div>
                    <div className='skill-card' data-aos='fade-left'>
                        <img src={js} alt='icon' className='hoverable' />
                        <h3>JavaScript</h3>
                    </div>
                    <div className='skill-card' data-aos='fade-right'>
                        <img src={react1} className='hoverable' alt='icon' />
                        <h3>React Js</h3>
                    </div>
                </div>
            </section>
        </>
    );
}

function MyServices() {
    return(
        <>
            <section className='services-section'>
                <div className='header-container' data-aos="fade-up">
                    <h2 className='header-text'>My Services</h2>
                    <div className='tags'></div>
                </div>
                <div className='services'>
                    <div data-aos='fade-up'>
                        <img src={landing} className='hoverable' alt='service' />
                        <h3>Landing Pages</h3>
                    </div>
                    <div data-aos='fade-up'>
                        <img src={pwa} className='hoverable' alt='service' />
                        <h3>PWA Web Apps</h3>
                    </div>
                    <div data-aos='fade-up'>
                        <img src={webapp} className='hoverable' alt='service' />
                        <h3>Web Applications</h3>
                    </div>
                    <div data-aos='fade-up'>
                        <img src={custom} className='hoverable' alt='service' />
                        <h3>Custom Web Sites</h3>
                    </div>
                    <div className='services-bug' data-aos='fade-up'>
                        <img src={responsive} className='hoverable' alt='service' />
                        <h3>Responsive Web Sites</h3>
                    </div>
                </div>
            </section>
        </>
    );
}

function Projects() {
    return(
        <>
            <section id='projects-section' className='projects'>
                <div className='header-container' data-aos="fade-up">
                    <h2 className='header-text'>My Projects</h2>
                    <div className='tags'></div>
                </div>
                <div className='tutorial-div'>
                    <div data-aos='fade-right'>
                        <img src={touch} alt='tutorial'/>
                        <p>Tap to view projects</p>
                        <br />
                    </div>
                    <div data-aos='fade-left'>
                        <img src={touchLeft} alt='tutorial'/>
                        <p>Swipe to switch projects</p>
                    </div>
                </div>
        
                <div className='projects-container'>
                    <div className='project' data-aos='fade-right'>
                        <div className='info'>
                            <p className='project-name'>Telegram Clone</p>
                            <p>
                                <i className='fa-solid fa-gear ipr'></i>
                                html, css, javascript
                            </p>
                            <a target='_blank' href='https://telegram-webk-clone.netlify.app'>
                            <button className='custom-btn'>
                                <i className='fa-solid fa-link ipr'></i>
                                Open
                            </button>
                            </a>
                        </div>
                    </div>
                    <div className='project' data-aos='fade-right'>
                        <div className='info'>
                            <p className='project-name'>Foydali Sayt</p>
                            <p>
                                <i className='fa-solid fa-gear ipr'></i>
                                html, css, javascript
                            </p>
                            <a target='_blank' href='https://foydali-sayt.netlify.app'>
                            <button className='custom-btn'>
                                <i className='fa-solid fa-link ipr'></i>
                                Open
                            </button>
                            </a>
                        </div>
                    </div>
                    <div className='project' data-aos='fade-right'>
                        <div className='info'>
                            <p className='project-name'>Weather App</p>
                            <p>
                                <i className='fa-solid fa-gear ipr'></i>
                                react js
                            </p>
                            <a target='_blank' href='https://obhavo-uzb.netlify.app'>
                            <button className='custom-btn'>
                                <i className='fa-solid fa-link ipr'></i>
                                Open
                            </button> 
                            </a>
                        </div>
                    </div>
                    <div className='project' data-aos='fade-right'>
                        <div className='info'>
                            <p className='project-name'>Music Player</p>
                            <p>
                                <i className='fa-solid fa-gear ipr'></i>
                                html, css, javascript
                            </p>
                            <a target='_blank' href='https://music-playeruz.netlify.app'>
                            <button className='custom-btn'>
                                <i className='fa-solid fa-link ipr'></i>
                                Open
                            </button> 
                            </a>
                        </div>
                    </div>
                    <div className='project' data-aos='fade-right'>
                        <div className='info'>
                            <p className='project-name'>Crypto Tracker</p>
                            <p>
                                <i className='fa-solid fa-gear ipr'></i>
                                react js
                            </p>
                            <a target='_blank' href='https://price-trackeruz.netlify.app'>
                            <button className='custom-btn'>
                                <i className='fa-solid fa-link ipr'></i>
                                Open
                            </button> 
                            </a>
                        </div>
                    </div>
                    <div className='project' data-aos='fade-right'>
                        <div className='info'>
                            <p className='project-name'>UZ Wiki</p>
                            <p>
                                <i className='fa-solid fa-gear ipr'></i>
                                react js
                            </p>
                            <a target='_blank' href='https://wikiuz.netlify.app'>
                            <button className='custom-btn'>
                                <i className='fa-solid fa-link ipr'></i>
                                Open
                            </button> 
                            </a>
                        </div>
                    </div>
                    <div className='project' data-aos='fade-right'>
                        <div className='info'>
                            <p className='project-name'>Shopping Cards</p>
                            <p>
                                <i className='fa-solid fa-gear ipr'></i>
                                html, css, javascript
                            </p>
                            <a target='_blank' href='https://shopping-cards.netlify.app'>
                            <button className='custom-btn'>
                                <i className='fa-solid fa-link ipr'></i>
                                Open
                            </button> 
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

function Contact() {
    function verify() {
        if (document.getElementById('yourname').value.length > 3) {
            if (document.getElementById('youremail').value.length > 13) {
                if (document.getElementById('youremail').value.padEnd('@gmail.com')) {
                    if (document.getElementById('yourmsg').value.length > 2) {
                        alert('Message Send!');
                    } else {
                        alert('ERROR: Enter correctly');
                    }
                } else {
                    alert('ERROR: Enter correctly');
                }
            } else {
                alert('ERROR: Enter correctly');
            }
        } else {
            alert('ERROR: Enter correctly');
        }
    }
    
    return(
        <>
            <section id='contact-section' className='contact'>
                <div className='header-container' data-aos="fade-up">
                    <h2 className='header-text'>Contact Me</h2>
                    <div className='tags'></div>
                </div>
                <div className='contact-container' data-aos='fade-up'>
                    <label>
                        Your Name
                        <input id='yourname' type='text' require />
                    </label>
                    <label>
                        Your Email
                        <input id='youremail' type='email' require />
                    </label>
                    <textarea id='yourmsg'></textarea>
                    <input className='submit custom-btn' value='Submit' type='submit' onClick={verify}/>
                </div>
            </section>
        </>
    );
}

function Footer() {
    return(
        <>
            <div className='footer'>
                <h3>© {new Date().getFullYear()} Sardor Ziyotov</h3>
            </div>
        </>
    );
}

function AdminPanel() {
    function Unlock() {
        if (document.getElementById('lockarea').value === '26052007zs') {
            document.getElementById('locked-page').style.display = 'none';
            document.getElementById('unlocked-page').style.display = 'block';
            setTimeout(() => {
                document.getElementById('myModal1').style.display = 'none';
                document.getElementById('myModal1').setAttribute('id','unlockedd');
                
                document.getElementById('phonenum').setAttribute('href','tel:+998973228805');
                document.getElementById('resume').setAttribute('href','/');
                document.getElementById('openmap').setAttribute('href','https://goo.gl/maps/HEfVGgQxSNc53s5z9');
            }, 1000)
        } else {
            document.getElementById('err').innerHTML = 'Wrong Password!';
        }
    }
    
    return(
        <>
            <div id="myModal1" className="modal">
                <div className="modal-content" id='modal-content1'>
                    <div id='locked-page'>
                        <h3>This section is locked by admin</h3>
                        <label>
                            Enter the password
                            <input type='text' id='lockarea' />
                        </label>
                        <p id='err'></p>
                        <button className='custom-btn' onClick={Unlock}>OK</button>
                    </div>
                    <div id='unlocked-page'>
                        <h3>This Page Unlocked</h3>
                    </div>
                    <i className='fa-solid fa-x' style={{cursor: 'pointer', fontSize: '1.3rem', color: 'black'}} onClick={() => document.getElementById('myModal1').style.display = 'none'}></i>
                </div>
            </div>
        </>
    );
}

export { Loader, Nav, Main, AboutMe, MySkills, MyServices, Projects, Contact, Footer, AdminPanel };